import styled from 'styled-components';

import style from '../../style';

export const SmallTitle = styled.h2(({ theme: { color, font, size } }) => ({
  fontFamily: font.family,
  fontStyle: 'normal',
  fontWeight: font.weight.bold,
  fontSize: size.units(4),
  lineHeight: size.units(5),
  color: color.content.primary.default(),

  ...style.mixins.responsive.sm.downward({
    fontSize: size.units(3),
    lineHeight: size.units(4),
  }),

  ...style.mixins.responsive.xs.downward({
    fontSize: size.units(3),
    lineHeight: size.units(4),
  }),
}));
